export const contentTableConfig = {
  title: '用户列表',
  propList: [
    { prop: 'empNo', label: '员工编号', minWidth: '80' },
    { prop: 'nickName', label: '昵称', minWidth: '60' },
    { prop: 'realName', label: '真实姓名', minWidth: '60' },
    { prop: 'deptName', label: '部门', minWidth: '100' },
    { prop: 'empTag', label: '员工标签', minWidth: '80', slotName: 'empTag' },
    {
      prop: 'isManager',
      label: '是否经理',
      minWidth: '100',
      slotName: 'manager'
    },
    { prop: 'status', label: '状态', minWidth: '60', slotName: 'status' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      slotName: 'createdTime'
    },
    {
      prop: 'lastLoginTime',
      label: '最后登录时间',
      minWidth: '120'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ]
}
